import * as React from 'react';

import {useQuery} from '@apollo/react-hooks';

import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {UppercaseLabel} from 'shells/typography/uppercase-label';

import type {
    GetNewsletterEngagementStats as GetNewsletterEngagementStatsQuery,
    GetNewsletterEngagementStatsVariables as GetNewsletterEngagementStatsQueryVariables,
} from 'nutshell-graphql-types';

import {EngagementBar} from '../../engagement/engagement-bar';

import GET_EDITION_ENGAGEMENT_STATS from '../graphql/queries/get-newsletter-engagement-stats.graphql';

import {NewsletterEditionStats} from './newsletter-edition-stats';

type Props = {
    campaignId: string;
};

export function NewsletterEngagement(props: Props) {
    const {data, loading: isLoading} = useQuery<
        GetNewsletterEngagementStatsQuery,
        GetNewsletterEngagementStatsQueryVariables
    >(GET_EDITION_ENGAGEMENT_STATS, {
        variables: {newsletterId: props.campaignId},
    });

    const sentEditions =
        data && data.newsletter
            ? data.newsletter.editions.edges
                  .map((edge) => edge.node)
                  .filter((edition) => edition.status === 'SENT')
            : [];

    return (
        <StackLegacy spacing={16}>
            <EngagementBar
                engagementStats={data && data.newsletter ? data.newsletter.engagementStats : null}
                isLoading={isLoading}
            />
            <StackLegacy spacing={8}>
                <UppercaseLabel>Sent editions</UppercaseLabel>
                <NewsletterEditionStats editions={sentEditions} isLoading={isLoading} />
            </StackLegacy>
        </StackLegacy>
    );
}
